/*function convertArrayOfObjectsToCSV(args) {
    var result, ctr, keys, columnDelimiter, lineDelimiter, data;

    data = args.data || null;
    if (data == null || !data.length) {
        return null;
    }

    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';

    keys = Object.keys(data[0]);

    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;

    data.forEach(function(item) {
        ctr = 0;
        keys.forEach(function(key) {
            if (ctr > 0) result += columnDelimiter;

            result += item[key];
            ctr++;
        });
        result += lineDelimiter;
    });

    return result;
}

export default convertArrayOfObjectsToCSV;*/

function convertArrayOfObjectsToCSV(args) {
    var result, ctr, columnDelimiter, lineDelimiter, data;
    var keys = [];

    data = args.data || null;
    if (data == null || !data.length) {
        return null;
    }

    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';

    //keys = Object.keys(data[0]);

    for (var key in data[0]) {
        if (key !== "id" && key !== "children" && key !== 'paymentDetails' && key !== 'paymentMethod'
            && key !== 'providerId' && key !== 'commentsStore' && key !== 'commentsManager' &&
            (args.excludeKey && !args.excludeKey.includes(key))) {

            keys.push(key);
        }
    }

    result = '';

    if (args.header) {
        result += args.header.join(columnDelimiter);
        result += lineDelimiter;
    }

    if (args.translated) {
        let translated = [];
        for (let indx in keys) {
            translated.push(args.translated[keys[indx]]);
        }

        result += translated.join(columnDelimiter);
    } else {
        result += keys.join(columnDelimiter);
    }

    let arrBoolToText = [];

    if (args.boolTotext) {
        arrBoolToText = args.boolTotext;
    }

    result += lineDelimiter;

    data.forEach(function (item) {
        ctr = 0;
        keys.forEach(function (key) {
            if (ctr > 0) result += columnDelimiter;

            if (arrBoolToText.includes(key)) {
                result += (item[key] === 0 || item[key] === '0') ? 'לא' : 'כן';
            }
            else {
                if(key === 'executorDetails' || key === 'address' || key === 'name' || key === 'admin_comment' || key === 'dealText') {
                    let tmp = "";
                    if(item[key] !== undefined && item[key] !== null) {
                        tmp = item[key].replace(/[\n\r]|,/g, "");
                    }
                    tmp = tmp.replace(/\t/g, ' ');
                    result += tmp;
                    //result += item[key].replace(/[\n\r\t]|,/g, ""); //.replace(/,/g, "");
                }
                else if(key === 'is_duplicate') {
                    result += (item[key] === 0) ? 'לא' : (item[key] === 1) ? 'המקור' : 'השכפול';
                }
                else {
                    result += item[key];
                }
            }
            ctr++;
        });
        result += lineDelimiter;
    });

    return result;
}

export default convertArrayOfObjectsToCSV;


/*function convertArrayOfObjectsToCSV(args) {
    var result, ctr, ctrSon, keys, keysSon, columnDelimiter, lineDelimiter, data;

    data = args.data || null;
    if (data == null || !data.length) {
        return null;
    }

    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';

    keys = Object.keys(data[0]);

    if(data[0].children.length > 0) {
        keysSon = Object.keys(data[0].children[0]);
    }

    let tmpStr = "";
    keys.forEach(function(str) {
        if(str !== "children") {
            tmpStr += str + columnDelimiter;
        }
    });

    result = '';
    //result += keys.join(columnDelimiter);
    result = tmpStr;
    result += lineDelimiter;

    data.forEach(function(item) {
        ctr = 0;
        keys.forEach(function(key) {

            if(key === "children") {
                result += lineDelimiter;
                item[key].forEach(function(itemSon) {
                    ctrSon = 0;
                    keysSon.forEach(function(keySon) {
                        if (ctrSon > 0) result += columnDelimiter;

                        result += itemSon[keySon];
                        ctrSon++;
                    });
                    result += lineDelimiter;
                });
            }
            else {
                if (ctr > 0) result += columnDelimiter;

                result += item[key];
                ctr++;
            }
        });
        result += lineDelimiter;
    });

    return result;
}

export default convertArrayOfObjectsToCSV;*/